module.exports = __webpack_public_path__ + "static/media/cw.f1b3043c.svg";